<style lang="scss" scoped>
.hospitalAdd-wrap-out {
    .hospitalAdd-wrap {
        // height: calc(100vh);
        background: #ffffff;
        margin: 20px;
        overflow: hidden;
        padding: 20px 20px 0px 20px;
        box-shadow: 0 1px 4px 0 hsla(0, 0%, 79%, 0.5);
        .hospital-title {
            padding-bottom: 8px;
            font-size: 14px;
            color: #333333;
            border-bottom: 1px solid #cccccc;
            i {
                color: $color-primary;
            }
            span {
                margin-left: 8px;
            }
        }
        .hospatial-base-info {
            border-bottom: 1px solid #cccccc;
            padding-top: 20px;
        }
        .info-title {
            margin-bottom: 20px;
            border-left: 4px solid $color-primary;
            padding-left: 8px;
            height: 16px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            line-height: 16px;
            color: #333333;
            text-align: left;
        }
        .cert-info {
            border-bottom: none;
            .papers-uploader {
                .icon {
                    font-size: 140px;
                }
            }
            .heart-warning {
                // margin-top: 10px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #999999;
                letter-spacing: 0;
                line-height: 16px;
            }
        }
    }
    .add-btn-bottom {
        width: 100%;
        height: 60px;
        background: #f9f9f9;
        border-top: 1px solid #e8e8e8;
        display: flex;
        align-items: center;
        justify-content: center;
    }
}
</style>
<template>
    <div class="hospitalAdd-wrap-out">
        <div>
            <bread-crumb :bread-list="breadList" />
        </div>
        <div class="hospitalAdd-wrap" v-loading="loading">
            <div class="hospital-title">
                <!-- <svg-icon icon-class="tongyong" class-name="tongyong" /><span>医院信息</span> -->
                <i class="iconfont icon-tongyongbiaotiicon"></i
                ><span>医院信息</span>
            </div>
            <el-form :model="ruleForm" ref="ruleForm" class="rule-from">
                <div class="hospatial-base-info">
                    <div class="info-title">基本信息</div>
                    <el-row>
                        <el-col :span="8">
                            <el-form-item
                                label="医院名称"
                                label-width="98px"
                                prop="hospitalName"
                                :rules="[
                                    {
                                        required: true,
                                        message: '请输入医院名称'
                                    }
                                ]"
                            >
                                <!-- <el-input v-model.trim="ruleForm.hospitalName"
                                          placeholder="请输入医院名称"
                                          :style="{width: '210px'}"
                                          size="small"
                                          maxlength="20"></el-input> -->
                                <el-autocomplete
                                    v-model="ruleForm.hospitalName"
                                    size="small"
                                    value-key="hospitalName"
                                    :style="{ width: '210px' }"
                                    :fetch-suggestions="searchAllHospital"
                                    :trigger-on-focus="false"
                                    @select="handleSelect"
                                    @keyup.native="toLisener"
                                    placeholder="请输入医院名称"
                                ></el-autocomplete>
                            </el-form-item>
                            <el-form-item
                                label="医院权限"
                                label-width="98px"
                                prop="hospitalLevel"
                            >
                                <el-select
                                    v-model="ruleForm.hospitalPowerCode"
                                    clearable
                                    :style="{ width: '210px' }"
                                    size="small"
                                    @change="changePowerValue"
                                    @clear="changePowerValue"
                                    placeholder="请选择医院权限"
                                >
                                    <el-option
                                        v-for="(item,
                                        index) in hospitalPowerList"
                                        :key="index"
                                        :label="item.dictDataValue"
                                        :value="item.dictDataCode"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item
                                label="医院属性"
                                label-width="98px"
                                prop="hospitalAttributeCode"
                                :rules="[
                                    {
                                        required: true,
                                        message: '请选择医院属性'
                                    }
                                ]"
                            >
                                <el-select
                                    v-model="ruleForm.hospitalAttributeCode"
                                    clearable
                                    :style="{ width: '210px' }"
                                    size="small"
                                    @change="changeArrValue"
                                    @clear="changeArrValue"
                                    placeholder="请选择医院属性"
                                >
                                    <el-option
                                        v-for="(item, index) in hospitalArrList"
                                        :key="index"
                                        :label="item.dictDataValue"
                                        :value="item.dictDataCode"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="医院别名" label-width="104px">
                                <el-input
                                    v-model.trim="ruleForm.hospitalNameOther"
                                    :style="{ width: '210px' }"
                                    placeholder="请输入医院别名"
                                    size="small"
                                    maxlength="20"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="医院权限等级"
                                label-width="104px"
                            >
                                <el-select
                                    v-model="ruleForm.hospitalPowerLevelCode"
                                    clearable
                                    :style="{ width: '210px' }"
                                    size="small"
                                    @change="changeQxLevelValue"
                                    @clear="changeQxLevelValue"
                                    placeholder="请选择医院权限等级"
                                >
                                    <el-option
                                        v-for="(item,
                                        index) in hospitalQxLevelList"
                                        :key="index"
                                        :label="item.dictDataValue"
                                        :value="item.dictDataCode"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item
                                label="机构代码"
                                label-width="104px"
                                prop="originCode"
                            >
                                <!-- :rules="[{ required: true, message: '请输入医院名称'}]"> -->
                                <el-input
                                    v-model.trim="ruleForm.originCode"
                                    :style="{ width: '210px' }"
                                    size="small"
                                    maxlength="20"
                                    placeholder="请输入机构代码"
                                ></el-input>
                            </el-form-item>
                            <el-form-item
                                label="医院等级"
                                label-width="104px"
                                prop="hospitalLevelCode"
                                :rules="[
                                    {
                                        required: true,
                                        message: '请选择医院等级'
                                    }
                                ]"
                            >
                                <el-select
                                    v-model="ruleForm.hospitalLevelCode"
                                    clearable
                                    :style="{ width: '210px' }"
                                    size="small"
                                    @change="changeLevelValue"
                                    @clear="changeLevelValue"
                                    placeholder="请选择医院等级"
                                >
                                    <el-option
                                        v-for="(item,
                                        index) in hospitalLevelList"
                                        :key="index"
                                        :label="item.dictDataValue"
                                        :value="item.dictDataCode"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </div>
                <!-- <div class="hospatial-base-info">
                    <div class="info-title">详细介绍</div>
                    <el-form-item class="form-details"
                                  label="详细介绍"
                                  label-width="98px"
                                  prop="details"
                                  :rules="[{ required: true, message: '请输入详细介绍'}]">
                        <el-input v-model.trim="ruleForm.details"
                                  type="textarea"
                                  :style="{width: '720px',height: '132px'}"
                                  placeholder="请输入详细介绍"
                                  maxlength="150"
                                  show-word-limit
                                  class="introduction-detail"></el-input>
                    </el-form-item>
                </div> -->
                <div class="hospatial-base-info cert-info">
                    <div class="info-title">认证信息</div>
                    <el-form-item label="法人姓名" label-width="156px">
                        <el-input
                            v-model.trim="ruleForm.legalPersonName"
                            :style="{ width: '240px' }"
                            placeholder="请输入法人姓名"
                            maxlength="20"
                            size="small"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="联系电话"
                        label-width="156px"
                        prop="contactPhone"
                        :rules="[
                            { required: true, message: '请输入联系电话' },
                            {
                                pattern: /^((0\d{2,3}-\d{7,8})|(1[3456789]\d{9}))$/,
                                message: '输入正确的联系电话'
                            }
                        ]"
                    >
                        <el-input
                            v-model.trim="ruleForm.contactPhone"
                            placeholder="请输入联系电话"
                            :style="{ width: '240px' }"
                            size="small"
                        ></el-input>
                    </el-form-item>
                    <el-form-item
                        label="所在地区"
                        label-width="156px"
                        class="form-address"
                        required
                    >
                        <el-col class="province_inner_wrap">
                            <el-form-item
                                prop="provinceCode"
                                class="province_inner"
                                :rules="[
                                    { required: true, message: '请选择省' }
                                ]"
                            >
                                <el-select
                                    v-model="ruleForm.provinceCode"
                                    @change="changeProvince"
                                    clearable
                                    :style="{ width: '164px' }"
                                    size="small"
                                    placeholder="请选择省"
                                    class="content-region"
                                >
                                    <el-option
                                        :label="item.name"
                                        v-for="(item, index) in provinceList"
                                        :key="index"
                                        :value="item.code"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col class="city_inner">
                            <el-form-item
                                prop="cityCode"
                                :rules="[
                                    { required: true, message: '请选择市' }
                                ]"
                            >
                                <el-select
                                    v-model="ruleForm.cityCode"
                                    clearable
                                    :style="{ width: '164px' }"
                                    size="small"
                                    @change="changeCity"
                                    placeholder="请选择市"
                                    class="content-city"
                                >
                                    <el-option
                                        :label="item.name"
                                        v-for="(item, index) in cityList"
                                        :key="index"
                                        :value="item.code"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>

                        <el-col class="district_inner">
                            <el-form-item
                                prop="districtCode"
                                :rules="[
                                    { required: true, message: '请选择区/县' }
                                ]"
                            >
                                <el-select
                                    v-model="ruleForm.districtCode"
                                    clearable
                                    :style="{ width: '164px' }"
                                    size="small"
                                    placeholder="请选择区/县"
                                    class="content-city"
                                >
                                    <el-option
                                        :label="item.name"
                                        v-for="(item, index) in areaList"
                                        :key="index"
                                        :value="item.code"
                                    ></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col class="address_inner_wrap">
                            <el-form-item
                                prop="address"
                                class="address_inner"
                                :rules="[
                                    {
                                        required: true,
                                        message: '请输入详细地址'
                                    }
                                ]"
                            >
                                <el-input
                                    v-model.trim="ruleForm.address"
                                    type="textarea"
                                    placeholder="请输入详细地址"
                                    class="address-detail"
                                    maxlength="200"
                                ></el-input>
                            </el-form-item>
                        </el-col>
                    </el-form-item>
                    <el-form-item label="法人身份证" label-width="156px">
                        <el-upload
                            class="papers-uploader"
                            :action="picUrl"
                            :on-success="handleCardFrontSuccess"
                            :on-remove="handleCardFrontRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile"
                            list-type="picture-card"
                            :file-list="idCardFrontFileList"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="sfz_renxiang" />
                        </el-upload>

                        <el-upload
                            class="papers-uploader"
                            :action="picUrl"
                            :on-success="handleCardEndSuccess"
                            list-type="picture-card"
                            :file-list="idCardEndFileList"
                            :on-remove="handleCardEndRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile"
                            accept=".jpg, .png, .jpeg"
                        >
                            <svg-icon icon-class="sfz_guohui" />
                        </el-upload>
                        <div class="heart-warning">
                            请上传身份证的正反面，建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1284px*810px
                        </div>
                    </el-form-item>
                    <el-form-item
                        label="医疗机构执业许可证"
                        label-width="156px"
                    >
                        <el-upload
                            class="papers-uploader"
                            :action="picUrl"
                            :on-success="handleInstitutionSuccess"
                            list-type="picture-card"
                            :file-list="medicalLicenseFileList"
                            :on-remove="handleInstitutionRemove"
                            :on-preview="handlePictureCardPreview"
                            :before-upload="beforeUploadProfile2"
                            accept=".jpg, .png,.jpeg"
                        >
                            <svg-icon icon-class="license-" />
                        </el-upload>
                        <div class="heart-warning">
                            建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1599*1155px
                        </div>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="add-btn-bottom">
            <el-button
                type="warning"
                size="small"
                @click="handleCreate()"
                :disabled="flag"
                >创 建</el-button
            >
            <el-button type="info" size="small" plain @click="cancleCreate()"
                >取 消</el-button
            >
        </div>
        <!-- <el-dialog :visible.sync="dialogVisible" class="ww-dialog">
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog> -->
        <el-dialog
            :visible.sync="dialogVisible"
            :show-close="false"
            @close="clearUrl"
            width="600px"
            class="ww-pre-dialog"
        >
            <img width="100%" :src="dialogImageUrl" alt="" />
            <span slot="title">
                <el-image
                    class="icon-delete"
                    :src="deleteUrl"
                    @click="handleImgClose"
                >
                </el-image>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import { checkFileSize } from "@/utils/checkFiles";
export default {
    name: "hospitalAdd",
    data() {
        return {
            proFileUploadForm: {},
            picUrl: "",
            loading: false,
            flag: false,
            provinceList: [],
            cityList: [],
            areaList: [],
            ruleForm: {
                hospitalName: "", // 医院名称
                hospitalNameOther: "", // 医院别名
                provinceName: "", // 省份
                provinceCode: "", // 省份code
                cityName: "", // 市
                cityCode: "", // 市编码
                districtName: "", // 区、县
                districtCode: "", // 区code
                address: "", // 详细地址
                hospitalPowerCode: "", // 医院权限
                hospitalPowerName: "", // 医院权限
                hospitalAttributeCode: "", // 医院属性
                hospitalAttributeName: "", // 医院属性
                hospitalLevelName: "", // 医院等级
                hospitalLevelCode: "", // 医院等级
                hospitalPowerLevelCode: "", // 医院权限等级
                hospitalPowerLevelName: "", // 医院权限等级
                originCode: "", // 机构代码
                legalPersonIdcardFront: "", // 法人身份证正面
                legalPersonIdcardEnd: "", // 法人身份证反面
                medicalInstitutionLicense: "", // 医疗机构执业许可证
                contactPhone: "", // 联系电话
                legalPersonName: "" // 法人姓名
                // details: '' // 详细介绍
            },
            breadList: [
                { label: "医院管理" },
                { label: "医院列表", path: "/hospital/hospitalList" },
                { label: "新增医院" }
            ],
            dialogImageUrl: "", // 预览
            dialogVisible: false, // 预览显示
            idCardFrontFileList: [],
            idCardEndFileList: [],
            medicalLicenseFileList: [],
            oldHosName: "", // 旧的选择的医院
            deleteUrl: require("../../../assets/imgs/delete.png")
        };
    },
    computed: {
        ...mapGetters(["dictionary", "userInfo", "collapseMenu"])
    },
    created() {
        this.getAddressData("province", 1, "", "");
        this.getSelect();
        this.picUrl = `/ms-hoc-video/v1/image/upload?hospitalId=${this.userInfo.hospitalId}&iuid=${this.userInfo.iuid}&ImageType=HOSPITAL_INFO_IMAGE`;
    },
    methods: {
        // 上传图片之前 限制
        beforeUploadProfile(file) {
            this.proFileUploadForm = new FormData();
            this.proFileUploadForm.append("upfiles", file);
            return checkFileSize(
                file,
                this,
                2,
                "请上传身份证的正反面，建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1284px*810px"
            );
        },
        beforeUploadProfile2(file) {
            return checkFileSize(
                file,
                this,
                2,
                "建议图片小于2M，图片格式为png、jpg、jpeg，图片尺寸建议1599*1155px"
            );
        },
        // 搜索互联网医院
        async searchAllHospital(queryString, cb) {
            if (queryString) {
                const params = {
                    searchName: queryString
                };
                const {
                    results
                } = await this.$services.hospital.getAllInterHospitalList(
                    params
                );
                if (!results) {
                    let a = [];
                    cb(a);
                } else {
                    cb(results);
                }
            }
        },
        // 处理信息 选择互联网医院 数据渲染
        handleSelect(data) {
            this.handleClear();
            this.oldHosName = data.hospitalName;
            if (data.provinceCode) {
                this.getAddressData("province", 1, "", "");
                this.getAddressData("city", 2, data.provinceCode, "");
            }
            if (data.cityCode) {
                this.getAddressData("area", 3, data.cityCode, "");
            }
            if (
                data.legalPersonIdcardFront &&
                data.legalPersonIdcardFront !== "0"
            ) {
                this.idCardFrontFileList = [
                    {
                        name: "",
                        url:
                            "/ms-hoc-video/v1/image/download?fileName=" +
                            data.legalPersonIdcardFront
                    }
                ];
            }
            if (
                data.legalPersonIdcardEnd &&
                data.legalPersonIdcardEnd !== "0"
            ) {
                this.idCardEndFileList = [
                    {
                        name: "",
                        url:
                            "/ms-hoc-video/v1/image/download?fileName=" +
                            data.legalPersonIdcardEnd
                    }
                ];
            }
            if (
                data.medicalInstitutionLicense &&
                data.medicalInstitutionLicense !== "0"
            ) {
                this.medicalLicenseFileList = [
                    {
                        name: "",
                        url:
                            "/ms-hoc-video/v1/image/download?fileName=" +
                            data.medicalInstitutionLicense
                    }
                ];
            }
            let list = this.ruleForm;
            for (let key in list) {
                for (let dKey in data) {
                    if (key === dKey && data[dKey] !== "0") {
                        list[key] = data[dKey];
                    }
                }
            }
        },
        // 清空医院信息
        handleClear() {
            let list = this.ruleForm;
            for (let key in list) {
                if (key !== "hospitalName") {
                    list[key] = "";
                }
            }
            this.idCardFrontFileList = [];
            this.idCardEndFileList = [];
            this.medicalLicenseFileList = [];
            this.oldHosName = "";
        },
        // 实现监听
        toLisener() {
            if (this.oldHosName) {
                if (
                    this.ruleForm.hospitalName !== this.oldHosName ||
                    !this.ruleForm.hospitalName
                ) {
                    this.handleClear();
                }
            }
        },
        // 获取省市区数据
        async getAddressData(type, level, pcode, searchName) {
            const param = {
                level: level,
                pcode: pcode,
                searchName: searchName
            };
            const { results } = await this.$services.user.getAddress(param);
            if (type === "province") {
                this.provinceList = results;
            } else if (type === "city") {
                this.cityList = results;
            } else if (type === "area") {
                this.areaList = results;
            }
        },
        changeProvince(value) {
            this.ruleForm.cityCode = "";
            this.ruleForm.districtCode = "";
            this.areaList = [];
            this.getAddressData("city", 2, value, "");
        },
        changeCity(value) {
            this.ruleForm.districtCode = "";
            this.getAddressData("area", 3, value, "");
        },
        changePowerValue(val) {
            let obj = {};
            obj = this.hospitalPowerList.find(item => {
                return item.dictDataCode === val;
            });
            if (val) {
                this.ruleForm.hospitalPowerName = obj.dictDataValue;
            } else {
                this.ruleForm.hospitalPowerName = "";
            }
        },
        changeArrValue(val) {
            let obj = {};
            obj = this.hospitalArrList.find(item => {
                return item.dictDataCode === val;
            });
            if (val) {
                this.ruleForm.hospitalAttributeName = obj.dictDataValue;
            } else {
                this.ruleForm.hospitalAttributeName = "";
            }
        },
        changeQxLevelValue(val) {
            let obj = {};
            obj = this.hospitalQxLevelList.find(item => {
                return item.dictDataCode === val;
            });
            if (val) {
                this.ruleForm.hospitalPowerLevelName = obj.dictDataValue;
            } else {
                this.ruleForm.hospitalPowerLevelName = "";
            }
        },
        changeLevelValue(val) {
            let obj = {};
            obj = this.hospitalLevelList.find(item => {
                return item.dictDataCode === val;
            });
            if (val) {
                this.ruleForm.hospitalLevelName = obj.dictDataValue;
            } else {
                this.ruleForm.hospitalLevelName = "";
            }
        },
        // 处理下拉列表
        getSelect() {
            this.hospitalPowerList = this.dictionary.YYQX;
            this.hospitalArrList = this.dictionary.YYSX;
            this.hospitalQxLevelList = this.dictionary.YYQXDJ;
            this.hospitalLevelList = this.dictionary.YYDJ;
        },
        // 身份证正面图片上传
        handleCardFrontSuccess(res, file) {
            let data = res.results;
            this.ruleForm.legalPersonIdcardFront = data[0].compressPictureId;
        },
        // 身份证反面图片上传
        handleCardEndSuccess(res, file) {
            let data = res.results;
            this.ruleForm.legalPersonIdcardEnd = data[0].compressPictureId;
        },
        // 营业执照许可证图片上传
        handleInstitutionSuccess(res, file) {
            let data = res.results;
            this.ruleForm.medicalInstitutionLicense = data[0].compressPictureId;
        },
        // 身份证正面图片删除
        handleCardFrontRemove(file, fileList) {
            this.ruleForm.legalPersonIdcardFront = "";
        },
        // 身份证反面图片删除
        handleCardEndRemove(file, fileList) {
            this.ruleForm.legalPersonIdcardEnd = "";
        },
        // 营业执照许可证图片删除
        handleInstitutionRemove(file, fileList) {
            this.ruleForm.medicalInstitutionLicense = "";
        },
        // 创建医院
        handleCreate() {
            this.$refs["ruleForm"].validate(valid => {
                if (valid) {
                    this.handlePostHospital();
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        // 创建医院请求
        async handlePostHospital() {
            this.loading = true;
            this.flag = true;
            let param = this.ruleForm;
            this.getAddressName(
                this.provinceList,
                this.ruleForm.provinceCode,
                "province"
            );
            this.getAddressName(this.cityList, this.ruleForm.cityCode, "city");
            this.getAddressName(
                this.areaList,
                this.ruleForm.districtCode,
                "area"
            );
            const { results } = await this.$services.hospital.createHospital(
                param
            );
            this.loading = false;
            this.flag = false;
            if (results) {
                this.$message({
                    message: "创建医院成功",
                    customClass: "hos-message--success",
                    iconClass: "el-icon-success",
                    duration: "1000"
                });
                this.$router.push("/hospital/hospitalList");
            }
        },
        // 取消创建
        cancleCreate() {
            this.$router.push("/hospital/hospitalList");
        },
        // 通过code 筛选name
        getAddressName(list, code, type) {
            list.forEach(v => {
                if (v.code === code) {
                    switch (type) {
                        case "province":
                            this.ruleForm.provinceName = v.name;
                            break;
                        case "city":
                            this.ruleForm.cityName = v.name;
                            break;
                        case "area":
                            this.ruleForm.districtName = v.name;
                            break;
                        default:
                            console.log("error");
                    }
                }
            });
        },
        handlePictureCardPreview(file) {
            let reg = new RegExp("ZIP");
            file.url = file.url.replace(reg, "");
            this.dialogImageUrl = file.url;
            this.dialogVisible = true;
        },
        clearUrl() {
            this.dialogImageUrl = "";
        },
        handleImgClose() {
            this.dialogVisible = false;
        }
    }
};
</script>
